import { DEFAULT_API_BASE_URL } from "./app";

export type RuntimeConfig = {
  apiBaseUrl?: string;
  webPushPublicKey?: string;
  googleAuthEnabled?: boolean;
  appleAuthEnabled?: boolean;
};

declare global {
  interface Window {
    __WATER_TRACKER_CONFIG__?: RuntimeConfig;
  }
}

export function getRuntimeConfig(): RuntimeConfig {
  return window.__WATER_TRACKER_CONFIG__ ?? {};
}

export function getApiBaseUrl(): string {
  const runtimeValue = getRuntimeConfig().apiBaseUrl;
  const viteValue = import.meta.env.VITE_API_BASE_URL as string | undefined;
  return trimTrailingSlash(runtimeValue ?? viteValue ?? DEFAULT_API_BASE_URL);
}

export function getWebPushPublicKey(): string {
  const runtimeValue = getRuntimeConfig().webPushPublicKey;
  const viteValue = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY as string | undefined;
  return runtimeValue ?? viteValue ?? "";
}

export function isGoogleAuthEnabled(): boolean {
  return getRuntimeConfig().googleAuthEnabled ?? isTruthyEnv(import.meta.env.VITE_ENABLE_GOOGLE_AUTH as string | undefined);
}

export function isAppleAuthEnabled(): boolean {
  return getRuntimeConfig().appleAuthEnabled ?? isTruthyEnv(import.meta.env.VITE_ENABLE_APPLE_AUTH as string | undefined);
}

export function trimTrailingSlash(value: string): string {
  return value.endsWith("/") ? value.slice(0, -1) : value;
}

function isTruthyEnv(value: string | undefined): boolean {
  return value === "true" || value === "1" || value === "yes";
}
